import * as React from "react";
const SvgMinimizeOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M6 19h12v2H6v-2z" />
  </svg>
);
export default SvgMinimizeOutlined;
